<template>
	<div class="fun_box">
		<div class="contentBox" style="padding-top: 20px;">
			<h2>功能查询</h2>
			<div class="fun_list">
				<div class="fun_one fun" @click="tofinish">
					<img src="../../../static/images/com_images/icon_07.png" alt="">
					<span>已完成案件查询</span>
				</div>
				<div class="fun_one fun">
					<img src="../../../static/images/com_images/icon_08.png" alt="">
					<span @click="toadd()">保险公司合同管理</span>
				</div>
				<div class="fun_one fun">
					<img src="../../../static/images/com_images/icon_08.png" alt="">
					<span @click="toserve()">设置授权费用</span>
				</div>
				<!-- <div class="fun_one fun">
					<img src="../../../static/images/com_images/icon_08.png" alt="">
					<span @click="toContractsStatic">保险公司合同管理2</span>
				</div> -->
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				token:
					this.$route.params.token || JSON.parse(window.localStorage.getItem("data")).data
			};
		},		
		methods: {
			tofinish() {
				this.$router.push({
					name: "finishEnd",
					params: {
						token: this.token
					}
				});
			},
			toadd() {
        console.log(window.location.host)
        // this.$router.push({
				// 	name: "wListRegulators",
				// 	params: {
				// 		token: this.token
				// 	}
				// });
        var url = '';
        if(SEVSRS == 'http://api.test.dajiuxing.com.cn/') {
          url = "http://api.test.dajiuxing.com.cn/rescue/user/wListRegulators?token=" + this.token;
        }else {
          url = "http://api.dajiuxing.com.cn/rescue/user/wListRegulators?token=" + this.token;
        }
				window.location.href =url 
			},
			toserve() {
        // this.$router.push({
				// 	name: "wToService",
				// 	params: {
				// 		token: this.token
				// 	}
				// });
        var url = '';
        if(SEVSRS == 'http://api.test.dajiuxing.com.cn/') {
          url = "http://api.test.dajiuxing.com.cn/rescue/user/wToService?token=" + this.token;
        }else {
          url = "http://api.dajiuxing.com.cn/rescue/user/wToService?token=" + this.token;
        }
				window.location.href =url
			}
		}
	};
</script>

<style scoped>
	.fun_box {
		background-color: white;
		padding: 0 0 50px 0;
	}

	.contentBox {
		width: 1200px;
		margin: 0 auto;
	}

	h2 {
		font-size: 20px;
		color: #333;
	}

	.fun_one {
		margin-top: 20px;
		cursor: pointer;
	}

	.fun_one img {
		vertical-align: middle;
	}

	.fun_one span {
		vertical-align: middle;
		font-size: 18px;
		padding-left: 10px;
		color: #666;
	}

	.warnBox {
		overflow: hidden;
		padding: 50px 0;
	}

	.warnBox img {
		float: left;
	}

	.warnBox .overflow {
		float: left;
		margin-left: 20px;
	}

	.warnBox .overflow h3 {
		font-size: 18px;
		font-weight: normal;
	}

	.warnBox .overflow p {
		font-size: 14px;
		line-height: 30px;
		color: #666;
	}

	.warnBox .text {
		float: right;
		color: #666;
	}

	.fun_list {
		overflow: hidden;
	}

	.fun_list .fun_one {
		float: left;
		margin-left: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/views/cmd_center/footer.vue